import { Form, Row, Col, Button } from "react-bootstrap";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  editModal,
  openModal,
  resetFormState,
  setSelectValidError,
} from "../../../../slices/common/reducer";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
// import { createOrganization } from "./OrganizationService";
import { getOrgId, getOrgType } from "../../../../Utils/CommonUtils";
import { OrgRelationshipModalLayoutJSON } from "../Json/OrgRelationshipLayoutJson";
import { createOrgRelationship, updateOrgRelationship } from "../OrgRelationshipService";

const AddNewOrgRelationshipModal = () => {
  const dispatch = useDispatch();
  const modalShow = useSelector((state) => state.common.modalShow);
  const edit = useSelector((state) => state.common.editShow);
  const formState = useSelector((state) => state.common.formRendererState);
  const orgRelationshipFieldsJson = useSelector(
    (state) => state.organizationRelationship.orgRelationshipFieldsJson
  );
  const OrgRelationUpdateId = useSelector((state) => state.organizationRelationship.orgRelationshipEdit.id);
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const organizationId = selectedUser.organizationid;
  const organizationType = getOrgType();

  const handleClose = () => {
    dispatch(openModal(false));
    dispatch(editModal(false));
    dispatch(resetFormState());
    // dispatch(setRolesEditID(null));
    dispatch(setSelectValidError(false));
  };

  const addNewClickHandler = (e) => {
    e.preventDefault();
    if (formState.status) {
      dispatch(setSelectValidError(false));
      createOrgRelationship(formState, organizationId, organizationType );
    } else {
      dispatch(setSelectValidError(true));
    }
  };


  const updateClickHandler = (e) => {
    e.preventDefault();
    if (formState.status) {
      dispatch(setSelectValidError(false));
      updateOrgRelationship(formState);
    } else {
      dispatch(setSelectValidError(true));
    }
  };

  return (
    <Modal
      isOpen={modalShow}
      onHide={() => handleClose()}
      centered
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
    >
      <Form className="tablelist-form"  onSubmit={edit === false ? addNewClickHandler : updateClickHandler}>
        <ModalHeader className="p-3 bg-info-subtle" toggle={handleClose}>
          {/* {"New Organization"} */}
          {edit ? "Update Org Relationship" : "New Org Relationship"}
        </ModalHeader>
        <ModalBody className="modal-body">
          <Row className="g-3">
            <Col lg={12}>
              {OrgRelationshipModalLayoutJSON.map((element) => (
                <div key={element.elementid}>
                  {element.child.map((child) =>
                    renderElement(child, orgRelationshipFieldsJson, formState)
                  )}
                </div>
              ))}
            </Col>
            <Col lg={12}>
              <div className="hstack gap-2 justify-content-end">
                {/* <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => handleClose(false)}
                >
                  Close
                </button> */}
                {/* <Button
                  onClick={handleClose}
                  className="primary primary_button"
                  id="addNewMember"
                >
                  {edit ? "Update" : "Cancel"}
                </Button> */}
                <Button
                  type="submit"
                  className="primary primary_button"
                  id="addNewMember"
                >
                  {edit ? "Update" : "Save"}
                </Button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default AddNewOrgRelationshipModal;
